import { Card, CardContent } from "@/components/card";
import { LogoAnimation } from "@/components/Logo/logoAnimation";

export const LoadingScreen = () => {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <Card className="w-72 h-36 flex justify-center items-center">
        <CardContent className="pt-6">
          <LogoAnimation size={24} variant="spin" />
        </CardContent>
      </Card>
    </div>
  );
};
